import { applyFieldLogic } from './apply-field-logic';
import { cleanFormData } from './clean-form-data';
import { computeDefaults } from './compute-defaults';
import { getDynamicOptions } from './get-dynamic-options';
import { getFileNaming } from '../../utils/get-filenaming';

export const getESPNHeroHelpers = () => ({
  getDynamicOptions,
  cleanFormData,
  applyFieldLogic,
  computeDefaults,
  getFileNaming
});
